import {
	track as BrazeTrack,
} from './Braze.js';
import Stats from 'frontend_stats';
import FullstoryUtil from 'fullstory_util';
import { devLog, promiser, getUser, HeapUtil } from 'core/utils';
import appboy from 'appboy';
import Cookies from 'js-cookie';
import ApiRequest from 'core/api/request';

const IDENTIFY_COOKIE = `tr-segment`;
const COOKIE_INTERVAL_DAYS = 1;

/**
 * Track an event across multiple channels at once
 * @param {String} eventName
 * @param {Object} services names of the services to track
 *                 each service can have an array of arguments to pass
 *                 pass an empty array to just track an event without args
 * @example
 * trackEvent('impression', {braze: [{ data }], fullstory: []});
 */
export const trackEvent = async (eventName, services = {}) => {
	if (services.braze !== undefined) {
		const data = services.braze[0] || {};
		BrazeTrack(eventName, data);
	}

	if (services.heap !== undefined) {
		const data = services.heap[0] || {};
		devLog({ eventName: `${eventName} Heap`, args: services.heap });
		HeapUtil.track(eventName, data);
	}

	if (services.statjoy !== undefined) {
		devLog({ eventName: `${eventName} Statjoy`, args: services.statjoy });
		Stats.trackGeneric(eventName, ...services.statjoy);
	}

	if (services.fullstory !== undefined) {
		devLog({ eventName: `${eventName} Fullstory`, args: services.fullstory });
		FullstoryUtil.sendEvent(eventName, ...services.fullstory);
	}

	if (services.justuno !== undefined) {
		if (typeof window.juapp === 'function') {
			devLog({ eventName: `${eventName} Justuno`, args: services.justuno });
			const data = services.justuno[0] || {};
			if (eventName === 'order') {
				// Order conversion, has 3 args
				window.juapp(eventName, data.orderId.toString(), data);
				data.orderItems.forEach(item => {
					// Have to send one event per item on an order
					window.juapp('orderItem', item);
				});
			} else {
				// Right now just add to cart
				window.juapp(eventName, data);
			}
		}
	}

	if (services.gtag !== undefined) {
		devLog({ eventName: `${eventName} gtag`, args: services.gtag });
		if (window && window.gtag) {
			window.gtag("event", eventName, ...services.gtag);
		}
	}
};

/**
 * identify a known user and update its attributes everywhere
 *
 * @param {bool} force skip cookie usage
 */
export const identify = async ({ force }) => {
	const user = getUser();
	if (! user) return;
	const id = user.id;
	const emailHash = user?.email_hash;
	appboy.changeUser(`${id}`);

	// Handle multiple users on same computah
	const cookie = Cookies.get(IDENTIFY_COOKIE);
	if (cookie && cookie === emailHash && !force) return;
	const [error, res] = await promiser(ApiRequest.get("/t/a/"));
	if (error) devLog(error);
	// Check for cookie
	// If no cookie or expired fire ApiRequest
	devLog({ trackingIdentifyRes: res });
	Cookies.set(IDENTIFY_COOKIE, emailHash, { expires: COOKIE_INTERVAL_DAYS });
};

const TrackUtil = {
	trackEvent,
	identify,
};

export default TrackUtil;
